import React from 'react'

import { AnalysisGeneration } from 'types/AnalysisGeneration'

import { useAnalysis } from 'redux/hooks/Analyses'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import CompletedSection from 'components_new/molecules/CompletedSection'
import StatusBox from 'components_new/molecules/StatusBox'

import AnalysisItem from 'components_new/organisms/analyses/AnalysisItem'

interface CompletedAnalysisProps {
  onGoTo?: () => void
  result: AnalysisGeneration
}

const CompletedAnalysis = (props: CompletedAnalysisProps) => {
  const { onGoTo, result } = props

  const { t } = useTranslation()
  const { analysis } = useAnalysis(result.analysis_id)

  const ambiguous = analysis?.meta?.ambiguous_real_estates ?? []

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <CompletedSection
        background={true}
        direction="column"
        sx={{ minHeight: 200 }}
        title={t('analysis_types', 'done_title')}
        variant="logo"
      />
      {ambiguous.length > 0 ? (
        <StatusBox
          allowClose={false}
          severity="warning"
          size="small"
          title={t('analyses', 'ambiguous_title')}
        >
          {t(
            'analyses',
            ambiguous.length === 1 ? 'ambiguous_body_one' : 'ambiguous_body',
            false,
            { names: ambiguous.join(', ') }
          )}
        </StatusBox>
      ) : null}
      <AnalysisItem
        disableBorder={true}
        disablePadding={true}
        id={result.analysis_id}
        onGoTo={onGoTo}
        sx={{ widht: '100%' }}
      />
    </Box>
  )
}

export default CompletedAnalysis
